
import { defineComponent } from "vue";
import axios from "axios";
import meetlookup from "../MeetLookup";
import { Club, ClubAthlete } from "@/types/Club";
import { Athlete } from "@/types/Athlete";
import AthletesTable from "@/components/AthletesTable.vue";
import PullRefresh from "pull-refresh-vue3";

export default defineComponent({
  mixins: [meetlookup],
  components: {
    AthletesTable,
    PullRefresh,
  },
  props: {
    athleteid: {
      type: String,
      required: false,
    },
    meetid: {
      type: String,
      required: true,
    },
    clubid: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      club: (null as unknown) as Club,
      athletesFocus: [] as Array<Athlete>,
      isLoading: false,
    };
  },
  methods: {
    fetchMulti() {
      this.fetch(
        this.club.athletes.filter((athlete) => athlete.id == this.athleteid),
        this.athletesFocus
      );
    },

    fetch(clubAthletes: Array<ClubAthlete>, athletes) {
      // TODO: Fix DataType
      for (let idx = 0; idx < clubAthletes.length; idx++) {
        axios
          .get(
            "https://live.swimrankings.net/meets/" +
              this.meetid +
              "/athletes/" +
              clubAthletes[idx].id +
              ".json",
            { params: { t: new Date().getTime() } }
          )
          .then((response) => response.data as Athlete)
          .then((athlete) => {
            for (let idx = 0; idx < athlete.results.length; idx++) {
              if (
                this.get_seconds_from_swimrankingstime(athlete.results[idx].swimtime) <
                this.get_seconds_from_swimrankingstime(athlete.results[idx].entrytime)
              ) {
                athlete.results[idx].isPb = true;
              } else {
                athlete.results[idx].isPb = false;
              }
              var performance =
                this.get_seconds_from_swimrankingstime(athlete.results[idx].entrytime) /
                this.get_seconds_from_swimrankingstime(athlete.results[idx].swimtime);
              athlete.results[idx].performance = performance * performance;
              athlete.results[idx].eventnr = this.get_event_number_from_event_id(
                athlete.results[idx].eventid
              );
            }
            athlete.results.sort(function (result_a, result_b) {
              if (result_a.eventnr && result_b.eventnr) {
                return (
                  result_a.eventnr - result_b.eventnr ||
                  parseInt(result_a.eventid) - parseInt(result_b.eventid)
                );
              }
              return 0;
            });

            for (let idx = 0; idx < athlete.entries.length; idx++) {
              athlete.entries[idx].eventnr = this.get_event_number_from_event_id(
                athlete.entries[idx].eventid
              );
            }
            athlete.entries.sort(function (entry_a, entry_b) {
              if (entry_a.eventnr && entry_b.eventnr) {
                return (
                  entry_a.eventnr - entry_b.eventnr ||
                  parseInt(entry_a.eventid) - parseInt(entry_b.eventid)
                );
              }
              return 0;
            });

            athletes.push(athlete);

            athletes.sort(function (athlete_a, athlete_b) {
              var sort_name = 1;
              if (athlete_b.fullname > athlete_a.fullname) {
                sort_name = -1;
              }
              return (
                parseInt(athlete_a.gender) - parseInt(athlete_b.gender) ||
                athlete_b.age - athlete_a.age ||
                sort_name
              );
            });
          });
      }
    },
    onRefresh() {
      this.isLoading = true;
      this.athletesFocus = [];
      this.update_meet();
      this.fetchMulti();
      this.isLoading = false;
    },
  },
  mounted() {
    this.$gtag.event("live_pageload_athlete", {});
    axios
      .get(
        "https://live.swimrankings.net/meets/" +
          this.meetid +
          "/clubs/" +
          this.clubid +
          ".json",
        { params: { t: new Date().getTime() } }
      )
      .then((response) => {
        this.club = response.data;
        this.fetchMulti();
      });
  },
  computed: {},
});
